import axios from "../plugins/parseAxios";
export class MarketAPI {
  constructor(props) { }
  static getMarketArea(payload) {
    return axios.post("functions/getMarketArea", { id: payload.id });
  }
  static getMarketsSummaryInfo(ids) {
    return axios.post("functions/getMarketsSummaryInfo", { ids })
  }
  static getMarketsOccupancyRateInfo(ids, date) {
    return axios.post("functions/getMarketsOccupancyRateInfo", { ids, date })
  }
  static getMarket(id) {
    return axios.post("functions/getMarket", { id });
  }
  static updateMarket(payload) {
    return axios.post("functions/updateMarket", payload);
  }
  static getMarketByProject(projectId) {
    return axios.post("functions/getMarketByProject", { projectId });
  }
  static updateImageBase64(payload) {
    return axios.post("functions/updateImageBase64", payload);
  }
}
